import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import dedupedGet from '../utils/apiRequests';
import { getSession } from '../utils/session';

const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchCategories = useCallback(async () => {
    const { tenantId } = getSession();
    if (!tenantId) { setIsLoading(false); return; }
    setIsLoading(true);
    try {
      const response = await dedupedGet(`/api/v1/tenants/${tenantId}/categories?limit=500`);
      if (response.data?.data?.categories) {
        setCategories(response.data.data.categories.sort((a, b) => (a.order || 0) - (b.order || 0)));
      }
    } catch {}
    setIsLoading(false);
  }, []);

  useEffect(() => {
    fetchCategories();
    window.addEventListener('eclipse:tenant-changed', fetchCategories);
    return () => window.removeEventListener('eclipse:tenant-changed', fetchCategories);
  }, [fetchCategories]);

  return (
    <CategoryContext.Provider value={{ categories, isLoading, setCategories, refreshCategories: fetchCategories }}>
      {children}
    </CategoryContext.Provider>
  );
};

export const useCategoryContext = () => useContext(CategoryContext);
